"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentBoxColorThemes = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var b2c_theme_1 = require("../Theme/b2c-theme");
var Box_1 = __importDefault(require("../Box/Box"));
var getStateQuery_1 = __importDefault(require("../utils/getStateQuery"));
var ContentBoxColorThemes;
(function (ContentBoxColorThemes) {
    ContentBoxColorThemes["default"] = "default";
    ContentBoxColorThemes["white"] = "white";
    ContentBoxColorThemes["transparent"] = "transparent";
})(ContentBoxColorThemes = exports.ContentBoxColorThemes || (exports.ContentBoxColorThemes = {}));
var ContentBoxContainer = (0, styled_components_1.default)(Box_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  padding: 2.4rem;\n  border: ", ";\n  border-color: ", ";\n\n  ", "\n"], ["\n  background-color: ", ";\n  padding: 2.4rem;\n  border: ", ";\n  border-color: ", ";\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    switch (theme) {
        case ContentBoxColorThemes.white:
            return b2c_theme_1.colors.white;
        case ContentBoxColorThemes.transparent:
            return 'transparent !important';
        default:
            return b2c_theme_1.colors.box.defaultBackgroundColor;
    }
}, function (_a) {
    var bordered = _a.bordered;
    return bordered ? '1px solid' : 'none';
}, function (_a) {
    var bordered = _a.bordered, theme = _a.theme;
    if (bordered) {
        switch (theme) {
            case ContentBoxColorThemes.white:
                return b2c_theme_1.colors.box.whiteThemeBorderColor;
            default:
                return b2c_theme_1.colors.box.defaultBorderColor;
        }
    }
    return 'transparent';
}, function (_a) {
    var stackedBreakpoint = _a.stackedBreakpoint;
    return (0, getStateQuery_1.default)(stackedBreakpoint, "\n        display: flex;\n        background-color: ".concat(b2c_theme_1.colors.white, ";\n        padding: 2rem 0 0;\n      "));
});
var ContentBoxIconContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 2.4rem;\n  margin-bottom: 2.4rem;\n\n  ", "\n\n  ", "\n"], ["\n  height: 2.4rem;\n  margin-bottom: 2.4rem;\n\n  ", "\n\n  ", "\n"])), function (_a) {
    var stackedBreakpoint = _a.stackedBreakpoint;
    return (0, getStateQuery_1.default)(stackedBreakpoint, "\n        padding: 1rem 2.5rem;\n      ");
}, function (_a) {
    var leftAlignIcon = _a.leftAlignIcon;
    return leftAlignIcon && 'padding-left: 0 !important;';
});
var ContentBoxTextContainer = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var hideTextBorderMobile = _a.hideTextBorderMobile, stackedBreakpoint = _a.stackedBreakpoint;
    return (0, getStateQuery_1.default)(stackedBreakpoint, "\n        flex-grow: 2;\n        border: none;\n        padding-bottom: 1rem;\n        ".concat(hideTextBorderMobile
        ? ''
        : "border-bottom: 1px solid ".concat(b2c_theme_1.colors.box.whiteThemeBorderColor, ";"), "\n      "));
});
var ContentBoxTitle = styled_components_1.default.h3(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-family: '", "';\n  font-size: 1.2rem;\n  line-height: 1.6rem;\n  color: ", ";\n  text-transform: uppercase;\n  margin: 0 0 0.6rem;\n\n  ", "\n"], ["\n  font-family: '", "';\n  font-size: 1.2rem;\n  line-height: 1.6rem;\n  color: ", ";\n  text-transform: uppercase;\n  margin: 0 0 0.6rem;\n\n  ", "\n"])), function () { return b2c_theme_1.fonts.defaultMedium; }, function () { return b2c_theme_1.colors.primaryLightFontColor; }, function (_a) {
    var stackedBreakpoint = _a.stackedBreakpoint;
    return (0, getStateQuery_1.default)(stackedBreakpoint, "\n        font-size: 1rem;\n        line-height: 1.4rem;\n      ");
});
var ContentBoxText = styled_components_1.default.p(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  font-family: '", "';\n  font-size: 1.5rem;\n  line-height: 2.4rem;\n  color: ", ";\n  margin: 0;\n\n  ", "\n"], ["\n  font-family: '", "';\n  font-size: 1.5rem;\n  line-height: 2.4rem;\n  color: ", ";\n  margin: 0;\n\n  ", "\n"])), function () { return b2c_theme_1.fonts.defaultMedium; }, function () { return b2c_theme_1.colors.darkTitleFontColor; }, function (_a) {
    var stackedBreakpoint = _a.stackedBreakpoint;
    return (0, getStateQuery_1.default)(stackedBreakpoint, "\n        font-size: 1.4rem;\n        line-height: 2.2rem;\n      ");
});
var ContentBox = function (props) {
    var defaultProps = {
        hideTextBorderMobile: false,
        stackedBreakpoint: false,
        leftAlignIcon: false,
    };
    var _a = __assign(__assign({}, defaultProps), props), bordered = _a.bordered, hideTextBorderMobile = _a.hideTextBorderMobile, icon = _a.icon, stackedBreakpoint = _a.stackedBreakpoint, textContent = _a.textContent, theme = _a.theme, title = _a.title, leftAlignIcon = _a.leftAlignIcon, rest = __rest(_a, ["bordered", "hideTextBorderMobile", "icon", "stackedBreakpoint", "textContent", "theme", "title", "leftAlignIcon"]);
    return (react_1.default.createElement(ContentBoxContainer, __assign({ "data-testid": "content-box-container", bordered: bordered, stackedBreakpoint: stackedBreakpoint, theme: theme }, rest),
        icon && (react_1.default.createElement(ContentBoxIconContainer, { "data-testid": "content-box-icon", stackedBreakpoint: stackedBreakpoint, leftAlignIcon: leftAlignIcon }, icon)),
        react_1.default.createElement(ContentBoxTextContainer, { "data-testid": "content-box-text-container", hideTextBorderMobile: hideTextBorderMobile, stackedBreakpoint: stackedBreakpoint },
            react_1.default.createElement(ContentBoxTitle, { "data-testid": "content-box-title", stackedBreakpoint: stackedBreakpoint }, title),
            textContent && (react_1.default.createElement(ContentBoxText, { "data-testid": "content-box-text", stackedBreakpoint: stackedBreakpoint }, textContent)))));
};
exports.default = ContentBox;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=ContentBox.js.map


//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/eb-apps_b2c-site_b2c-site_master/node_modules/@urbanmassage/component-library/lib/ContentBox/ContentBox.js
// module id = 1578
// module chunks = 5 16 19 40